/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-06-29 20:58:46
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-08-25 14:45:50
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Currency/service/index.tsx
 */
import { getAllLanguage } from '@/src/request/common';
import { getCurrency, saveStoreCurrency } from '@/src/request/currency';
import { msg } from '@/src/tools/message';
import lodash from 'lodash';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { Currency, INITIAL_STATE } from '../constant';
import { Form } from '@/src/components/Antd';
import { get } from 'lodash';
import { conversionOptions } from '../constant';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
function useService(ignoreRequestLang?: boolean) {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [form] = Form.useForm();
  const history = useHistory();
  const [copy, setCopy] = useState<Array<any>>([]);
  const [currencyList, setCurrencyList] = useState<Array<any>>([]);
  const [editingCurrency, setEditingCurrency] = useState<any>(INITIAL_STATE);
  const [languages, setLanguages] = useState<Array<any>>([]);
  const [currencyFormat, setCurrencyFormat] = useState<any>('');
  const [currencyError, setCurrencyError] = useState<any>('');
  const [saveDisabled, setSaveDisabled] = useState<boolean>(true);
  const [reportingCurrency, setReportingCurrency] = useState<string>('');
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [deleteVisible, setDeleteVisible] = useState(false);
  const handleOnCurrencyDelete = () => {
    handleDeleteCurrency(selectedRecord);
  };
  const handleOnCurrencyModalClose = () => {
    setDeleteVisible(false);
    setSelectedRecord(null);
  };
  const handleOnCurrencyModalOpen = (record) => {
    setSelectedRecord(record);
    setDeleteVisible(true);
  };
  useEffect(() => {
    getCurrency().then((res: any) => {
      setCurrencyList(res.availableCurrencies);
      setCopy(res.availableCurrencies);
      setCurrencyFormat(res.currencyFormat);
      setReportingCurrency(res.reportingCurrency);
      //form data
      const data = {
        decimalPosition: get(res, 'decimalPosition'),
        conversionMode: get(res, 'conversionMode'),
        roundingRule: get(res, 'roundingRule'),
        truncateRule: get(res, 'truncateRule'),
        decimalSeparator: get(res, 'decimalSeparator'),
        thousandsSeparator: get(res, 'thousandsSeparator'),
      };
      form.setFieldsValue(data);
    });
    if (!ignoreRequestLang) {
      getAllLanguage().then((res: any) => {
        const languagesList = (res || []).map((item) => ({
          label: item.description,
          value: item.languageTag,
        }));
        setLanguages(languagesList);
      });
    }
  }, []);

  const navigateBack = () => {
    history.push('/settings');
  };

  const handleSubmit = () => {
    if (!currencyFormat) {
      setCurrencyError(true);
    } else {
      form.validateFields().then((res) => {
        const data = {
          availableCurrencies: currencyList,
          currencyFormat,
          ...res,
        };
        saveStoreCurrency(data).then((res: any) => {
          msg.success('Changes have been saved!');
          setCurrencyList(res.availableCurrencies);
          setCopy(res.availableCurrencies);
          setSaveDisabled(true);
        });
      });
    }
  };

  const handleCurrencyFormatChange = (value) => {
    if (!value) {
      setCurrencyError(true);
    } else {
      setSaveDisabled(false);
      setCurrencyFormat(value);
    }
  };

  const handleDiscard = () => {
    history.push('/settings');
  };

  const handleEditList = (currency: any) => {
    const list = lodash.cloneDeep(currencyList);
    const index = currencyList.findIndex(
      (c) => c.currencyCode === currency.currencyCode,
    );
    if (index !== -1) {
      const o = currencyList.find(
        (c) => c.currencyCode === currency.currencyCode,
      );
      list.splice(index, 1, { ...o, ...currency });
    } else {
      list.push(currency);
    }
    setCurrencyList(list);
  };

  const handleDeleteCurrency = (currency: Currency) => {
    if (currency.salesChannels?.length) {
      handleOnCurrencyModalClose();
      return;
    }
    let list: Array<Currency> = lodash.cloneDeep(currencyList);
    list = list.filter((l) => l.currencyCode !== currency.currencyCode);
    setCurrencyList(list);
    handleOnCurrencyModalClose();
  };

  const handleCleanAfterClose = () => {
    setEditingCurrency(INITIAL_STATE);
  };

  const handleEditCurrency = (currency: any) => {
    setEditingCurrency(currency);
  };

  const handleOnFormValuesChange = (changedValues, allValues) => {
    setSaveDisabled(false);
    handleOnDecimalPositionChange(allValues);
  };

  const handleOnDecimalPositionChange = (allValues) => {
    const _handleOnGetAmount = (rule): number => {
      const arr = conversionOptions({ getI18n });
      const o = arr.find((i) => rule === get(i, 'value'));
      return get(o, 'index');
    };
    const _handleOnGetValue = (index) => {
      const arr = conversionOptions({ getI18n });
      const o = arr.find((i) => index === get(i, 'index'));
      return get(o, 'value');
    };
    const decimalPosition = get(allValues, 'decimalPosition');
    const roundingRule = get(allValues, 'roundingRule');
    const truncateRule = get(allValues, 'truncateRule');
    if (roundingRule) {
      const index = _handleOnGetAmount(roundingRule);

      if (index > decimalPosition + 1) {
        const max = decimalPosition + 1;
        const v = _handleOnGetValue(max);
        form.setFieldsValue({ roundingRule: v });
      }
    }
    if (truncateRule) {
      const index = _handleOnGetAmount(truncateRule);
      if (index > decimalPosition + 1) {
        const max = decimalPosition + 1;
        const v = _handleOnGetValue(max);
        form.setFieldsValue({ truncateRule: v });
      }
    }
  };

  return {
    saveDisabled: !(!saveDisabled || !lodash.isEqual(copy, currencyList)),
    editingCurrency,
    currencyList,
    languages,
    currencyFormat,
    reportingCurrency,
    currencyError,
    handleCurrencyFormatChange,
    navigateBack,
    handleSubmit,
    handleEditList,
    handleDiscard,
    handleEditCurrency,
    handleDeleteCurrency,
    handleCleanAfterClose,
    form,
    getI18n,
    handleOnFormValuesChange,
    selectedRecord,
    deleteVisible,
    handleOnCurrencyDelete,
    handleOnCurrencyModalClose,
    handleOnCurrencyModalOpen,
  };
}

export default useService;
